import { colors, fontWeight } from '@cobliteam/ui/theme';
import { css } from 'emotion';

export const cluster = css`
  display: flex;
  flex: 1;
  max-width: 80px;
  width: fit-content;
  min-width: 40px;
  padding: 3px;
  padding-left: 1px;
  border-radius: 10px;
  color: ${colors.white.DEFAULT};
  height: 22px;
  background: ${colors.gray[2]};
  border: 1px solid ${colors.gray[7]};
  font-weight: ${fontWeight.medium};
  filter: drop-shadow(
    0px 4px 4px ${colors.gray[9]}
  );
  transform: translateX(-50%);
  align-items: center;
  cursor: pointer;
  padding-right: 6px;

  & > div {
    min-width: 14px;
    text-align: center;
  }
`;
